<template>
  <footer class="footer" role="contentinfo">
    <div class="footer__inner">
      <div class="footer__section1">
        <div><p class="footer__slogan"><span>Зелёный Марафон</span><br>#создаваябудущее</p></div>
        <div>
          <div class="footer__logos">
            <div><img src="../assets/img/logos/sber-white.svg" alt="Сбер"></div>
            <div><img src="../assets/img/logos/marathon-white.svg" alt="Зеленый марафон"></div>
            <div><img src="../assets/img/logos/vklad-white.svg" alt="Вклад в будущее"></div>
            <div class="footer__social g-hidden-mobile">
              <a href="https://vk.com/green_marathon" target="_blank">
                <img src="../assets/img/icons/vk.svg" alt="Вконтакте">
              </a>
            </div>
          </div>
        </div>
        <div class="footer__social g-visible-mobile">
          <a href="https://vk.com/green_marathon" target="_blank">
            <img src="../assets/img/icons/vk.svg" alt="Вконтакте">
          </a>
        </div>
      </div>
      <div class="footer__section2">
        <div>
          <ul>
            <li>© 1997—2024 <a target="_blank" href="http://www.sberbank.ru/">ПАО СберБанк</a></li>
            <li>Россия, Москва, 117997, ул. Вавилова, 19.</li>
            <li>Генеральная лицензия на осуществление банковских операций от 11 августа 2015 года. Регистрационный
              номер — 1481.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
}
</script>